module.exports = __webpack_public_path__ + "static/media/MatscholarLogo.12052089.png";